/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneticsReportResponseDto
 */
export interface GeneticsReportResponseDto {
    /**
     * Genetics report ID
     * @type {string}
     * @memberof GeneticsReportResponseDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof GeneticsReportResponseDto
     */
    patientId: string;
    /**
     * Document name
     * @type {string}
     * @memberof GeneticsReportResponseDto
     */
    documentName: string;
    /**
     * File URL in storage
     * @type {string}
     * @memberof GeneticsReportResponseDto
     */
    fileUrl?: string;
    /**
     * File type
     * @type {string}
     * @memberof GeneticsReportResponseDto
     */
    fileType: GeneticsReportResponseDtoFileTypeEnum;
    /**
     * File size in bytes
     * @type {number}
     * @memberof GeneticsReportResponseDto
     */
    fileSize?: number;
    /**
     * Upload datetime
     * @type {Date}
     * @memberof GeneticsReportResponseDto
     */
    uploadedAt?: Date;
    /**
     * Creation datetime
     * @type {Date}
     * @memberof GeneticsReportResponseDto
     */
    createdAt: Date;
    /**
     * Last update datetime
     * @type {Date}
     * @memberof GeneticsReportResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const GeneticsReportResponseDtoFileTypeEnum = {
    Pdf: 'pdf',
    Word: 'word',
    Image: 'image'
} as const;
export type GeneticsReportResponseDtoFileTypeEnum = typeof GeneticsReportResponseDtoFileTypeEnum[keyof typeof GeneticsReportResponseDtoFileTypeEnum];


/**
 * Check if a given object implements the GeneticsReportResponseDto interface.
 */
export function instanceOfGeneticsReportResponseDto(value: object): value is GeneticsReportResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('documentName' in value) || value['documentName'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GeneticsReportResponseDtoFromJSON(json: any): GeneticsReportResponseDto {
    return GeneticsReportResponseDtoFromJSONTyped(json, false);
}

export function GeneticsReportResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneticsReportResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'documentName': json['documentName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileType': json['fileType'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : (new Date(json['uploadedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function GeneticsReportResponseDtoToJSON(json: any): GeneticsReportResponseDto {
    return GeneticsReportResponseDtoToJSONTyped(json, false);
}

export function GeneticsReportResponseDtoToJSONTyped(value?: GeneticsReportResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'documentName': value['documentName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
        'fileSize': value['fileSize'],
        'uploadedAt': value['uploadedAt'] == null ? undefined : ((value['uploadedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

